import BaseFormMediator from './BaseFormMediator'
import OvertimeEditFormConfigController from './edit_config_controller/overtime/OvertimeEditFormConfigController'
import {arrayToMap} from '../atUtils'
import OvertimeReportStore from './overtimeReport/OvertimeReportStore'
import OvertimeCSVPreviewGenerator from './preview/csv/overtime/OvertimeCSVPreviewGenerator'
import OvertimeHTMLPreviewGenerator from './preview/html/overtime/OvertimeHTMLPreviewGenerator'
import ATReportParamsStringBuilder from './reportParamsStringBuilder/ATReportParamsStringBuilder'

export default function OvertimeFormMediator(){}

OvertimeFormMediator.prototype = new BaseFormMediator();

OvertimeFormMediator.prototype.init = function ( config ) {
    BaseFormMediator.prototype.init.call(this, config);

    ATReportsStore.setVisibleUsers(config.users);
    ATReportsStore.setUserGroups(config.userGroups);
    ATReportsStore.setTimeZoneGroups(config.timeZoneGroups);

    return this;
};

OvertimeFormMediator.prototype.initParamsStringBuilder = function(config) {
    return new ATReportParamsStringBuilder({
        data: {
            users: config.users,
            userGroups: config.userGroups,
            timeZoneGroups: config.timeZoneGroups,
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            projectsWithMaIds: ATReportsStore.getProjectsWithMaIds(),
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo(),
    })
}

OvertimeFormMediator.prototype.initEditConfigController = function ( config ) {
    var self = this;
    return new OvertimeEditFormConfigController().init(
        {
            panelId: "mainContainer",
            reportAuthorizationInfo: config.reportAuthorizationInfo,
            reportParameters: config.reportParameters,
            users: config.users,
            manageableUsersIds: config.manageableUserIds,
            userGroups: config.userGroups,
            timeZoneGroups: config.timeZoneGroups,
            changeCallback: function(){ self.changeParametersCallback()}
        } )
};

OvertimeFormMediator.prototype.initCsvGenerator = function(){
    return new OvertimeCSVPreviewGenerator().init();
};

OvertimeFormMediator.prototype.initHtmlGenerator = function(){
    return new OvertimeHTMLPreviewGenerator().init();
};

OvertimeFormMediator.prototype.exportToCSV = function() {
    const reportParams = this.collectReportParameters()

    const successMethod = (data) => {
        let info = {}
        const groupingLevels = BaseReport.ConvertUtils.getGroupingLevels(reportParams)
        for (let i = 0; i < data["groupingLevelsInfoLists"].length; ++i) {
            const groupingType = BaseReport.ConvertUtils.getGroupingType(i, groupingLevels)
            info[groupingType] = arrayToMap(data["groupingLevelsInfoLists"][i])
        }

        OvertimeReportStore.setReportData(data["rootItem"], info)
        OvertimeReportStore.setReportParams(reportParams)

        return new OvertimeCSVJsonConverter().init(OvertimeReportStore, ATReportsStore)
    }

    this._exportToCSV(reportParams, successMethod, "TimeBalanceAndOvertimeReportService.getReport", [this.makeServiceParams(reportParams)])
}

OvertimeFormMediator.prototype.fillDateSelection = function ( reportParametersObject )
{
    reportParametersObject.dateRangeSelection = this.dateRangeSelector.getSelectedRange();
};


// WEBPACK FOOTER //
// ./web/js/reports/OvertimeFormMediator.js